import React from 'react';
import ContactUsForm from './modules/contact-us';
const Contact = () => {
    return React.createElement(ContactUsForm, null);
};
export default Contact;
